/**
 * Interactive list of widgets
 */
import { useDispatch, useSelector } from 'react-redux';
import Text from '../../atoms/Text';
import { actionToggleWidget } from '../../actions/layout';
import { IStore } from '../../reducers';
import './styles.scss';

const Widgets = () => {
  const widgets: any = useSelector((state: IStore) => state.layout);
  const dispatch = useDispatch();
  const widgetKeys = Object.keys(widgets);

  const lockedWidgets = ['chart', 'trades'];

  const onClick = (widgetName: string, newValue: boolean) => {
    if (!lockedWidgets.includes(widgetName)) {
      dispatch(actionToggleWidget(widgetName, newValue));
    }
  };

  return (
    <div className='widgets'>
      <Text size={14} className='widgets__header text--weight-600'>
        Show widgets
      </Text>
      <div className='widgets__rows'>
        {widgetKeys.map((widgetName: string) => (
          <div
            key={widgetName}
            className={`widgets__row${!lockedWidgets.includes(widgetName) ? ' widgets__row--active' : ''}`}
            onClick={() => onClick(widgetName, !widgets[widgetName])}
          >
            <Text size={14}>{widgetName}</Text>
            {widgets[widgetName] && (
              <div
                className={`img ${
                  lockedWidgets.includes(widgetName) ? 'lock' : 'eye'
                }`}
              />
            )}
            {!widgets[widgetName] && <div className='img eyeOff' />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Widgets;
